module.exports = __webpack_public_path__ + "img/players.aca97b76.png";